// extracted by mini-css-extract-plugin
export default {"tabButtonsContainer":"TabButtons_tabButtonsContainer__Gtyhn","active":"TabButtons_active__Smj8B"};